import Chart from 'chart.js/auto';
// Importamos el plugin del treemap
import { TreemapController, TreemapElement } from 'chartjs-chart-treemap';

// REGISTRO OBLIGATORIO: Si no se registra, el tipo 'treemap' no existe para Chart.js
Chart.register(TreemapController, TreemapElement);

const chartColor = require('./chart-color');

export function start(detail) {
    obj[detail.act].start(detail);
}

const obj = {
    createSimple: { start: (detail) => { createSimple(detail); } },
};

function createSimple(detail) {
    const datos = {
        label: 'Item',
        tree: detail.data,
        key: 'value',
        groups: ['name'], // Asegúrate de que esto coincida con la propiedad de tu data

        borderWidth: 1,
        spacing: 0.1,
        backgroundColor: (ctx) => 'green',
        labels: {
            display: true,
            formatter(ctx) {
                const item = ctx.raw._data;
                return item.name + '\n' + item.value;
            },
            color: 'white',
            font: {
                size: 14,
                weight: 'bold'
            },
            align: 'center',
            position: 'middle'
        }
    }

    const setup = {
        type: 'treemap',
        data: {
            datasets: [datos]
        },
        options: {
            scales: {
                x: { display: false },
                y: { display: false }
            },
            plugins: {
                title: {
                    display: false,
                    text: '' //titulo de la grafica
                },
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        title: function (item, data) {
                            console.log(data)

                            return data.datasets[item[0].datasetIndex].key;
                        },
                        label: function (ctx) {
                            console.log(ctx)
                            console.log(data)
                            // var dataset = data.datasets[item.datasetIndex];
                            // var dataItem = dataset.data[item.index];
                            // return dataItem.v;
                        }
                    }
                }
            }
        }
    };

    // Aplicar opciones externas sin romper las escalas
    if (detail.options) {
        optionsCheck(detail, setup);
    }

    detail.targetChart.chart = new Chart(detail.targetChart.html, setup);
}

function optionsCheck(detail, setup) {
    if (!detail.options) return;
    if (detail.options.aspectRatio !== undefined) setup.options.aspectRatio = detail.options.aspectRatio;
    if (detail.options.legend !== undefined) setup.options.plugins.legend.display = detail.options.legend;
}

function colorFromValue(value, border) {
    var alpha = (1 + Math.log(value)) / 5;
    var color = "green";
    if (border) {
        alpha += 0.01;
    }
    return Chart.helpers.color(color)
        .alpha(alpha)
        .rgbString();
}